module.exports = __webpack_public_path__ + "static/media/logoSinLetras.2a656172.png";